<div class="road-not-available-modal">
  <fm-close-icon-button
    class="road-not-available-modal__close-icon"
    a7sId="modal-road-not-available-close"
    (closeClick)="onClose()"
  ></fm-close-icon-button>
  <span class="road-not-available-modal__title" i18n="@@S_LIVEMAP_MANAGE_POSTED_SPEED_ROAD_NOT_AVAILABLE_TITLE">Road not available</span>
  <span class="road-not-available-modal__description" i18n="@@S_LIVEMAP_MANAGE_POSTED_SPEED_ROAD_NOT_AVAILABLE_BODY">
    We could not find this road in our map data. This may happen with small, private, or new roads.
  </span>
  <div class="road-not-available-modal__buttons">
    <button
      mat-flat-button
      color="accent"
      class="btn-uppercase"
      (click)="onClose()"
      a7s-id="modal-road-not-available-ok"
      i18n="@@S_OK_BUTTON_LABEL"
      i18n-aria-label="@@S_OK_BUTTON_LABEL"
      aria-label="OK"
    >
      OK
    </button>
  </div>
</div>
